<!-- Mount all icon-like elements without attribute iconPositionEnd -->
<ng-content select="[badge-icon]:not([iconPositionEnd])"></ng-content>

<span class="fmnts-badge__content"><ng-content></ng-content></span>

<!-- Mount all icon-like elements with attribute iconPositionEnd -->
<ng-content select="[badge-icon][iconPositionEnd]"></ng-content>
